var i={wrapper:"lds-input--wrapper",input:"lds-input",withIcon:"lds-input--with-icon",icon:"lds-input--icon"};export{i as default};
